import { without, uniq } from 'lodash/fp';
import { ReactSortable } from "react-sortablejs";
import { preventDefault } from 'shared/events';
import ResponsiveVideo from 'shared/ResponsiveVideo';
import { humanizeErrors } from '../helpers/hasErrors';

export default class VideoLinks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {...props, newValue: ''};
  }

  localUpdate = (e) => this.setState({newValue: e.target.value})

  update = (value) => this.props.updateField({target: {value, name: this.props.fieldName}})

  addVideo = (e) => {
    const value = uniq([...(this.state.value || []), this.state.newValue]);

    this.setState({value, newValue: ''});
    this.update(value);
  }

  removeVideo = (url) => {
    const value = _.without(this.state.value, url);
    this.setState({value});
    this.update(value);
  }

  updateVideos = () => {
    this.update(this.state.value);
  }

  updateAspect = (url, aspectRatio) => {
    const value = this.state.value.map((v) => v === url ? `${url}#aspect=${aspectRatio}` : v);
    this.setState({value});
    this.update(value);
  }

  render() {
    const {error=[], has_errors} = this.props;
    const {value, newValue} = this.state;

    return (
      <div className={classnames("form-group", {error: error.length})}>
        <label>Share videos of your horse.</label>
        <div className={classnames('error-message', {has_errors})}>
          {humanizeErrors(error)}
        </div>
        {!_.isEmpty(value) &&
          <div className="file-preview pt-4">
            <div className="card-row">

          <ReactSortable
            list={value}
            setList={(value) => this.setState({value: value.map(v => v.toString())})}
            className="sortable"
            onSort={this.updateVideos}
          >
              {_.map(value, (url) => (
                <div className="card-column-photo" key={url}>
                  <div className="card bg-white">
                    <ResponsiveVideo src={url} updateAspect={(aspectRatio) => this.updateAspect(url, aspectRatio)}/>
                    <div className="row">
                      <div className="col-6">
                        <button type="button" className="file-action-button">
                          Move (drag)
                        </button>
                      </div>
                      <div className="col-6">
                        <button type="button"
                          className="file-action-button"
                          onClick={preventDefault(() => this.removeVideo(url))}>
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </ReactSortable>
            </div>
          </div>
        }
        <div className="input-group mt-4">
          <input type="text"
                 value={newValue}
                 className="form-control"
                 placeholder="Paste a YouTube, Tiktok, or Vimeo link here"
                 onChange={this.localUpdate}/>
          <button className="btn btn-primary"
            onClick={this.addVideo}
            disabled={newValue === ''}>
            Add
          </button>
        </div>
      </div>
    )
  }
}
